import { Box } from '@chakra-ui/react'
import { FieldMapValue, firstObVisitField } from '@hb/shared'
import { DataView } from '@components/DataView/DataView'

export const FirstObVisitView = ({ data }: { data: FieldMapValue }) => {
  const firstObVisit = data?.firstObVisit as FieldMapValue | undefined
  return (
    <Box w="100%">
      <DataView
        noHeader
        alwaysExpanded
        field={firstObVisitField}
        data={firstObVisit ?? {}}
        boxProps={{ border: 'none', borderBottom: 'none' }}
      />
    </Box>
  )
}
